module.exports = __webpack_public_path__ + "static/img/401.089007e.gif";